module.exports = __webpack_public_path__ + "img/four2Blue.d12de09a.jpg";